import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useGameCache } from './cache'
import { toResponseError, type GameCloseInput, type GameCloseSuccess, type GameData } from '@terros/common'

export function useCloseGame(): UpdateHookResponse<GameCloseInput, GameData> {
  const cache = useGameCache()
  const mutation = useTantalimMutation<GameCloseInput, GameCloseSuccess>({ url: '/game/close' })

  async function close(input: GameCloseInput): Promise<GameData> {
    try {
      const output = await mutation.mutateAsync(input)
      const newGame = output.game
      cache.updateGameData(newGame)
      return newGame
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationUpdate(mutation, close)
}
